<template>
	<div>
		<div class="body">
			<div class="body-main">
				<div class="main-head" v-if="loading">
					<div class="level">
						<p>用户级别<span style="float: right;">{{userInfo.user.id}}</span></p>
						<p>声望值<span style="float: right;">{{userInfo.user.prestige}}</span></p>
						<p>贡献值<span style="float: right;">{{userInfo.user.contribution}}</span></p>
						<p>积分值<span style="float: right;">{{userInfo.user.score}}</span></p>
					</div>
					<div class="detail">
						<div class="detail-pic">
							<div class="image"><img :src='getImgSrc(userInfo.user.avatar)' alt=""></div>
							<div v-if="userInfo.user_info">
								<div class="renzheng" v-if="userInfo.user_info.wechat_authentication">微信已认证</div>
								<div class="renzheng" style="background: #0052D9;color: white;" v-else>微信未认证</div>
							</div>
							
						</div>
						<div class="detail-content">
							<div class="top">
								<div style="display: flex;align-items: baseline;">
									<div class="username">{{userInfo.user.nickname}}</div>
									<div style="margin-left: 20px;" v-if="userInfo.record.company">
										<div style="background: #E5EDFA;color: #0052D9;padding:3px 10px;font-size: 14px;">{{userInfo.record.company}}</div>
									</div>
									<div style="margin-left: 20px;" v-if="arrc" v-for="(item, index) in arrc" :key="index"> 
										<div   style="background: #E5EDFA;color: #0052D9;padding:3px 10px;font-size: 14px;">
										  {{ item }}
										</div>
									</div>
								</div>
								<div style="display: flex;">
									<div class="fans cancelGuanzhu" v-if="userInfo.fans_status"  @click="toCancelFansNperson"><i class="el-icon-star-off"></i> 取消关注</div>
									<div class="fans guanzhu" v-else @click="toFansNperson"><i class="el-icon-star-off"></i> 关注他</div>
									
									<div class="fans letter" @click="$router.push(`/userCenter/pthd/myMessage?type=${3}&id=${userInfo.user.id}`)"><i class="el-icon-message" ></i> 站内信</div>
								</div>
							</div>
							<!-- <div class="company" v-if="userInfo.user_info">
								{{userInfo.user_info.company}}
							</div> -->
							<div class="jieshao">
								<p v-if="userInfo.cotent == ''" style="display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
									overflow: hidden;">这个用户很懒，什么也没留下...
								</p>
								<p v-else style="display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
									overflow: hidden;">{{userInfo.content}}
								</p>
								
							</div>
						</div>
					</div>
				</div>
				<div class="main-info">
					<div class="checkBox">
						<div @click="activeCheck = 1" :class="activeCheck == 1 ? 'checkActive':''">简历</div>
						<div @click="activeCheck = 2" :class="activeCheck == 2 ? 'checkActive':''">研究与项目</div>
						<div @click="activeCheck = 3" :class="activeCheck == 3 ? 'checkActive':''">平台活动</div>
					</div>
					<div class="jianli" v-show='activeCheck == 1'>
						<div class="dark-line">
							基本信息
						</div>
						<div class="main-info-userInfo" v-if="userInfo.record != null">
							<div class="left">
								<div>
									<div class="title">
										<div class="tit">姓名</div>
										<span>：</span>
										<p>{{userInfo.record.name}}</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">身份信息</div>
										<span>：</span>
										<p>{{userInfo.record.record}}</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">学位</div>
										<span>：</span>
										<p>{{userInfo.record.qualification}}</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">昵称</div>
										<span>：</span>
										<p>{{userInfo.record.job_title}}</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">行政职务</div>
										<span>：</span>
										<p>{{userInfo.record.duty}}</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">单位</div>
										<span>：</span>
										<div>
											<p>{{userInfo.record.company}}</p>
											<p v-for="item,index in strToArr(userInfo.record.company_extra)" :key="index">{{item}}</p>
										</div>
									</div>
								</div>

							</div>
							<div class="right">
								<div>
									<div class="title">
										<div class="tit">邮箱</div>
										<span>：</span>
										<div>
											<p>{{userInfo.record.email}}</p>
										</div>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">电话</div>
										<span>：</span>
										<div>
											<p>{{userInfo.record.phone}}</p>
										</div>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">行业领域</div>
										<span>：</span>
										<div v-if="userInfo.record.industry_ids_info !== ''">
											<p v-for="item,index in userInfo.record.industry_ids_info" :key="index">
												{{item.name}} 
										    </p>
										</div>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">兴趣方向</div>
										<span>：</span>
										<div>
											<p>{{userInfo.record.interest}}</p>
											<p v-for="item,index in strToArr(userInfo.record.interest_extra)" :key="index">{{item}}</p>
										</div>
									</div>
								</div>
								<div>
									<div class="title" v-if="loading" style="width: 100%;">
										<div class="tit" style="flex-shrink: 0;">个人主页</div>
										<span>：</span>
										<div style="overflow: hidden;flex-shrink: 0;flex: 1;padding-right: 10px;box-sizing: border-box;word-wrap: break-word">
											<p style="padding-right: 10px;word-wrap: break-word" v-if="userInfo.record.supplement">{{userInfo.record.supplement.remark}} <a  target="_blank" :href="userInfo.record.supplement.link">{{userInfo.record.supplement.link}}</a> </p>
											<p style="padding-right: 10px;word-wrap: break-word"  v-if="userInfo.record.supplement_extra">
												<p style="padding-right: 10px;word-wrap: break-word"  v-for="item,index in userInfo.record.supplement_extra" :key="index">
													{{item.remark}}  <a  target="_blank" :href="item.link">{{item.link}}</a>
												</p>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
							<el-empty :image-size="200"></el-empty>
						</div>
						<div class="dark-line">
							背书
						</div>
						<div class="beishu" v-if="loading">
							<div @click="centerDialogVisible = true" class="beishu-btn">
								添加背书
							</div>
							<div style="border-bottom: 1px solid #D2D2D2;"  v-if="userInfo.beishu.length">
								<div style="margin-bottom: 30px;" v-for="(item,index) in userInfo.beishu">
									<div class="beishu-item">
										<div class="dian"></div>
										<div style="margin-left: 10px;">{{item.beishu}}</div>
									</div>
									<p style="margin-left: 15px;color: #888;font-size: 14px;margin-top: 5px;">——{{item.beishuren}}
									</p>
								</div>
							</div>
							
							<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
								<el-empty :image-size="100"></el-empty>
							</div>
						<!-- 	<div class="beishu-inp">
								<input type="text" :placeholder="`给${userInfo.user.nickname}添加背书`">
								<div class="beishu-btn">
									添加背书
								</div>
							</div> -->
							<el-dialog
							  title="添加背书"
							  :visible.sync="centerDialogVisible"
							  width="500px"
							  center>
							<div class="beishu-inp">
								<input type="text" v-model="beishuStr" :placeholder="`给${userInfo.user.nickname}添加背书`">
							</div>
							  <span slot="footer" class="dialog-footer">
							    <el-button @click="centerDialogVisible = false">取 消</el-button>
							    <el-button type="primary" @click="addBeishu">确 定</el-button>
							  </span>
							</el-dialog>
							<div class="beishuPerson">
								<div v-for="(item,index) in userInfo.praise">
									<div class="dian"></div><span>{{item.praise_user_name}}背书了{{userInfo.user.nickname}}“{{item.industry_name}}”</span>
								</div>
								
							</div>
							<div class="goodfor"  v-if="userInfo.record">
								<p>擅长领域</p>
								<div class="good-item" v-if="userInfo.record.industry_ids_info !== ''">
									
									<div v-for="item,index in userInfo.record.industry_ids_info" :key="index" @click="cowManPraiseHandelr(item.id)">
										<!-- <p>{{userInfo.record.industry_ids_info.name}}</p> -->
										<p >
											{{item.name}}({{item.praise_num}})
									    </p>
									</div>
								</div>
								
							</div>
							<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
								<el-empty :image-size="100"></el-empty>
							</div>
						</div>
						<div class="dark-line">
							资格证书
						</div>
						<div class="zhengshu" v-if="imgList.length">
							<div class="img" v-for="(item,index) in imgList">
								<el-image style="width: 172px;height: 229px;" :src="item"
									:preview-src-list='imgList'>
								</el-image>
							</div>
						</div>
						<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
							<el-empty :image-size="200"></el-empty>
						</div>
					</div>
					<div class="yjandxm" v-show="activeCheck == 2">
						<div class="dark-line">
							接包项目
						</div>
						<div class="xmbox">
							<div v-if="takeProduct.total">
								<div class="box-item" v-for="(item,index) in takeProduct.data">
									<div class="title">{{item.title}}</div>
									<p style="display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;">{{item.summary_info}}</p>
								</div>
							</div>
							<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
							<div class="body-mid-footer" v-if="takeProduct.current_page < takeProduct.last_page" @click="getTakeBaoList(1)">
								加载更多<img src='../../assets/images/darrwo.png' alt="">
							</div>
						</div>
						<div class="dark-line">
							发包项目
						</div>
						<div class="xmbox">
							<div v-if="faProduct.total">
								<div class="box-item" v-for="(item,index) in faProduct.data">
									<div class="title">{{item.title}}</div>
									<p style="display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;">{{item.summary_info}}</p>
								</div>
							</div>
							<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
							<div class="body-mid-footer" v-if="faProduct.current_page < faProduct.last_page" @click="getTakeBaoList(1)">
								加载更多<img src='../../assets/images/darrwo.png' alt="">
							</div>
						</div>

					</div>
					<div class="hdpt" v-show="activeCheck == 3">
						<div class="dark-line">
							接包项目
						</div>
						<div style="padding: 30px 20px;">
							<el-table :data="jbList" stripe style="width: 100%" border="" @cell-click='clicktools'>
								<el-table-column prop="type" label="项目分类" width="141"  :resizable="false">
								</el-table-column>
							
								<el-table-column prop="subjectcate_name" label="科学分类" width="155"  :resizable="false">
								</el-table-column>
							 
								<el-table-column prop="title" label="行业分类" width="171"  :resizable="false">
								</el-table-column>
								<el-table-column prop="industry_name" label="资源分类" width="295"  :resizable="false">
							
								</el-table-column>
								<el-table-column prop="collect" label="关注量" width="154"  :resizable="false">
															
								</el-table-column>
								<el-table-column prop="score" label="评分" width="162" column-key="score"  :resizable="false">
									<template slot-scope="scope">
										<span style="color: red;">{{ scope.row.score }}</span>
									</template>
								</el-table-column>

							</el-table>
							<!-- <div style="display: flex;justify-content: center;margin-top: 15px;">
								<div class="body-mid-footer">
									加载更多<img src='../../assets/images/darrwo.png' alt="">
								</div>
							</div> -->
						</div>
						<div class="dark-line">
							发包项目
						</div>
						<div style="padding: 30px 20px;">
							<el-table :data="fbList" stripe style="width: 100%" border="" @cell-click='clicktools'>
								<el-table-column prop="type" label="项目分类" width="141"  :resizable="false">
								</el-table-column>
															
								<el-table-column prop="subjectcate_name" label="科学分类" width="155"  :resizable="false">
								</el-table-column>
															 
								<el-table-column prop="title" label="行业分类" width="171"  :resizable="false">
								</el-table-column>
								<el-table-column prop="industry_name" label="资源分类" width="295"  :resizable="false">
															
								</el-table-column>
								<el-table-column prop="collect" label="关注量" width="154"  :resizable="false">
															
								</el-table-column>
								<el-table-column prop="score" label="评分" width="162" column-key="score"  :resizable="false">
									<template slot-scope="scope">
										<span style="color: red;">{{ scope.row.score }}</span>
									</template>
								</el-table-column>
						
							</el-table>
						<!-- 	<div style="display: flex;justify-content: center;margin-top: 15px;">
								<div class="body-mid-footer">
									加载更多<img src='../../assets/images/darrwo.png' alt="">
								</div>
							</div> -->
						</div>
						<div class="dark-line">
							精彩评论
						</div>
						<div style="padding: 30px 20px;">
							<el-table :data="PLtableData" stripe style="width: 100%" border="" @cell-click='clicktools'>
								
							<!-- 
								<el-table-column prop="hdmc" label="活动名称" width="145"  :resizable="false">
								</el-table-column> -->
							 
								<el-table-column prop="user_nickname" label="评价者" width="182"  :resizable="false">
									
								</el-table-column>
								<el-table-column prop="remark" label="评价内容" width="520"  :resizable="false">
							
								</el-table-column>
								<el-table-column  label="评价时间" width="184"  :resizable="false">
									<template slot-scope="scope">
											<p>{{timeConversion(scope.row.updatetime)}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="score" label="评分" width="192" column-key="score"  :resizable="false">
									<template slot-scope="scope">
										<span style="color: red;">{{ scope.row.score }}</span>
									</template>
								</el-table-column>
						
							</el-table>
							
						</div>
						<!-- <div class="dark-line">
							荣誉和勋章
						</div>
						<div style="padding: 30px 20px;display: flex;align-items: center;flex-wrap: wrap;">
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
							<div style="margin-right: 20px;margin-top: 20px; background: #F6F6F6;height: 38px;padding: 0 20px;color: #0052D9;text-align: center;line-height: 38px;">文献达人(1级)</div>
						</div> -->
					</div>
					
				</div>
			</div>
			<div class="body-right">
				<div class="cowman">
					<div class="titel">
						<img src='../../assets/images/blueZ.png' style="width: 23px;height: 21px;" alt="">
						<p>牛人推荐</p>
					</div>
					<div class="item" v-for="(item,index) in recommendGeniusList.data">
						<div class="pic"  @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)"><img :src='getImgSrc(item.avatar)' alt=""></div>
						<div style="margin-left: 10px;">
							<p style="font-weight: bold;">{{item.nickname}}</p>
							<p style="color: #888;margin-top: 13px;font-size: 14px;">{{item.school}}</p>
						</div>
					</div>
					
				</div>
				<div class="cowman">
					<div class="titel">
						<img src='../../assets/images/paiming.png' style="width: 21px;height: 21px;" alt="">
						<p>排行榜</p>
					</div>
					<div class="item" v-for="(item,index) in GeniusScoreRank.data">
						<div class="pic"  @click="goto(`/geniusClub/geniusInfo?id=${item.id}`)"><img :src='getImgSrc(item.avatar)' alt=""></div>
						<div style="margin-left: 10px;">
							<p style="font-weight: bold;">{{item.nickname}}</p>
							<p style="color: #888;margin-top: 13px;font-size: 14px;">{{item.school}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


</template>

<script>
	export default {
		data() {
			return {
				arrc:[],
				beishuStr:'',
				centerDialogVisible:false,
				activeCheck: 1,
				PLtableData:[],
				userInfo:{},
				loading:false,
				recordInfo:{},
				imgList:[],
				takeProduct:[],
				takeProductPage:1,
				faProduct:[],
				faProductPage:1,
				jbList:[],
				fbList:[],
				recommendGeniusList:[],
				GeniusScoreRank:[]
			}
		},
		async created() {
			await this.getGeniusDetailInfo()
			this.getTakeBaoList()
			this.getFaBaoList()
			this.getJieBao()
			this.getNrList()
		},
		methods:{
			async addBeishu(){
				if(this.beishuStr == ''){
					this.$message({
						message: '背书内容不能为空',
						type: 'warning',
					})
					return
				}
				const bei = await this.$api.beiShuHandler({receive_user_id:this.userInfo.user.id,beishu:this.beishuStr})
				if (bei.code == 1) {
					this.$message({
						message: bei.msg,
						type: 'success',
					})
					this.beishuStr = ''
					this.centerDialogVisible = false
					this.getGeniusDetailInfo()
				} else {
					this.$message({
						message: bei.msg,
						type: 'warning',
					})
				}
			},
			async cowManPraiseHandelr(id){
				const praise = await this.$api.cowManPraise({industry_id:id,user_id:this.userInfo.user.id})
				if (praise.code == 1) {
					this.$message({
						message: praise.msg,
						type: 'success',
					})
					this.getGeniusDetailInfo()
				} else {
					this.$message({
						message: praise.msg,
						type: 'warning',
					})
				}
			},
			async getTakeBaoList(type){
				if(type == 1){
					this.takeProductPage++
					const list = await this.$api.geniusTakeBaoList({page:this.takeProductPage,user_id: this.userInfo.user.id})
					this.takeProduct.data = this.takeProduct.data.concat(list.data.data)
					this.takeProduct.current_page = list.data.current_page
					this.takeProduct.last_page = list.data.last_page
				}else{
					const list = await this.$api.geniusTakeBaoList({page:this.takeProductPage,user_id: this.userInfo.user.id})
					this.takeProduct = list.data
				}
			},
			async getNrList(){
				const list9 = await this.$api.recommendGeniusList()
				this.recommendGeniusList = list9.data
				const list3 = await this.$api.GeniusScoreRank()
				this.GeniusScoreRank = list3.data
			},
			async getFaBaoList(type){
				if(type == 1){
					this.faProductPage++
					const list = await this.$api.geniusFaBaoList({page:this.faProductPage,user_id: this.userInfo.user.id})
					this.faProduct.data = this.faProduct.data.concat(list.data.data)
					this.faProduct.current_page = list.data.current_page
					this.faProduct.last_page = list.data.last_page
				}else{
					const list = await this.$api.geniusFaBaoList({page:this.faProductPage,user_id: this.userInfo.user.id})
					this.faProduct = list.data
				}
			},
			
			async toCancelFansNperson(item) {
				const fans = await this.$api.cancelGeniusFans({
					user_id: this.userInfo.user.id
				})
				if (fans.code == 1) {
					this.$message({
						message: fans.msg,
						type: 'success',
					})
					this.userInfo.fans_status = 0
				} else {
					this.$message({
						message: fans.msg,
						type: 'warning',
					})
				}
			
			},
			async getJieBao(){
				const jb = await this.$api.jiebaohuodongList({user_id:this.userInfo.user.id})
				this.jbList = jb.data
				const fb = await this.$api.fabaohuodongList({user_id:this.userInfo.user.id})
				this.fbList = fb.data
				const pl = await this.$api.genNicePlList({user_id:this.userInfo.user.id})
				this.PLtableData = pl.data
				
			},
			async toFansNperson(item) {
				const fans = await this.$api.toFansGenius({
					user_id: this.userInfo.user.id
				})
				if (fans.code == 1) {
					this.$message({
						message: fans.msg,
						type: 'success',
					})
					this.userInfo.fans_status = 1
				} else {
					this.$message({
						message: fans.msg,
						type: 'warning',
					})
				}
			
			},
			goto(url){
				this.$router.push(url)
			},
			clickItem(column) {
				console.log(column)
				// this.$router.push(`/zyTools/zyQiuzDetail?id=${column.id}`)
			},
			clicktools(column){
				// this.$router.push(`/zyTools?id=${column.id}`)
			},
			strToArr(data){
				let str
				if(data != '' & data != null){
					str = data.split(',')
					return str
				}else{
					str = []
					return str
				}
				
			},
		    async getGeniusDetailInfo(){
				const info = await this.$api.getGeniusInfo({user_id:this.$route.query.id})
				// 处理公司额外信息
				console.log('其他单位',info.data.record.company_extra);
				if (info.data.record.company_extra) {
				    this.arrc = info.data.record.company_extra.split(',');
				}
				console.log('其他单位数组',this.arrc);
				this.userInfo = info.data
				this.loading = true
				if (info.data.record && info.data.record.certificate_images) {
				  const path = info.data.record.certificate_images.split(',');
				  this.imgList = path.map(item=> this.getImgSrc(item))
				  
				} else {
				  this.imgList = [];
				}
				
				
				console.log(info);
			}
		}
	}
</script>

<style scoped lang="less">
	.beishu-btn{
		width: 200px;
		height: 40px;
		background: #0052D9;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
		margin-bottom: 30px;
	}
	.beishu-inp{
		display: flex;
		align-items: center;
		justify-content: center;
		input{
			height: 30px;
			width: 400px;
			font-size: 16px;
			border-radius: 5px;
			border: 1px solid #c7c7c7;
			padding: 5px;
		}
	}
	.body-mid-footer {
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;
	
		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}
	/deep/.el-table__cell {
		color: #222222;
		text-align: center;
	}
	
	/deep/.el-input__inner {
		color: #222222;
	}
	
	/deep/.el-input__inner::placeholder {
		color: black !important;
	}
	
	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}
	.body {
		padding-top: 20px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.yjandxm {
			.xmbox {
				padding: 20px;

				.box-item {
					border-bottom: 1px dashed #E5E5E5;

					.title {
						font-size: 18px;
						font-weight: bold;
						margin-bottom: 20px;
					}

					p {
						color: #888;
						line-height: 24px;
						font-size: 15px;


					}

					padding: 20px 0;
				}
			}

			.body-mid-footer {
				margin-top: 30px;
				display: flex;
				padding: 20px;
				box-sizing: border-box;
				height: 50px;
				background: #F6F6F6;
				justify-content: center;
				font-size: 18px;
				cursor: pointer;
				align-items: center;

				&>img {
					margin-left: 20px;
					width: 16px;
					height: 16px;
				}
			}
		}

		.body-right {
			width: 260px;
			height: 535px;

			.cowman {
				margin-bottom: 20px;
				background: #FFFFFF;

				.item {
					display: flex;
					align-items: center;
					border-bottom: 1px dashed #EBEBEB;
					padding: 20px;
					box-sizing: border-box;
					padding-right: 5px;

					p {
						width: 90px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.pic {
						cursor: pointer;
						width: 54px;
						height: 54px;
						overflow: hidden;
						border-radius: 50%;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}

				.item:last-child {
					border: none;
				}
			}

			.titel {
				height: 60px;
				display: flex;
				background: #E5EDFB;
				font-weight: bold;
				font-size: 18px;
				align-items: center;
				padding-left: 15px;

				p {
					margin-left: 5px;
				}
			}
		}

		.body-main {
			.main-info {
				background: #FFFFFF;
				margin-top: 20px;

				.jianli {
					.zhengshu {
						display: flex;
						flex-wrap: wrap;
						padding: 30px 30px;

						.img {
							display: flex;
							justify-content: center;
							margin-right: 40px;
							margin-bottom: 30px;
						}
					}

					.goodfor {
						p {
							font-weight: bold;
						}

						.good-item {
							margin-top: 20px;
							display: flex;
							cursor: pointer;
							div {
								background: #E5EDFB;
								padding: 0 20px;
								margin-right: 15px;
								height: 35px;
								line-height: 35px;
								color: #0052D9;
								text-align: center;
							}
						}
					}

					.beishu {
						padding: 35px 30px;
						box-sizing: border-box;

						.beishu-item {
							display: flex;
							align-items: center;
						}

						.dian {
							display: inline-block;
							width: 5px;
							height: 5px;
							border-radius: 50%;
							background: #0052D9;
						}

						.beishuPerson {
							color: #888;
							// display: flex;
							align-items: center;
							margin: 25px 0;
							font-size: 14px;

							&>div {
								margin-top: 20px;
							}

							span {
								margin-left: 10px;
							}

							.dian {
								background-color: #888;
							}
						}
					}

				}

				.main-info-userInfo {
					display: flex;

					.left,
					.right {
						width: 50%;

						.title {
							margin-bottom: 15px;

							p {
								color: black;
								margin-left: 60px;
								margin-bottom: 15px;
							}

							display: flex;

							.tit {
								width: 78px;
								text-align: justify;
								text-align-last: justify;
							}

							color: #888888;
						}
					}

					padding:40px 20px;
					padding-bottom: 0px;
					box-sizing: border-box;
				}

				.dark-line {
					background: #F2F6FD;
					font-weight: bold;
					height: 56px;
					font-size: 18px;
					line-height: 56px;
					padding-left: 20px;
				}

				.checkBox {
					padding: 0 20px;
					font-size: 18px;
					display: flex;
					height: 80px;
					line-height: 80px;
					cursor: pointer;

					div {
						margin-right: 60px;
					}

					.checkActive {
						font-weight: bold;
						color: #0052D9;
						border-bottom: 3px solid #0052D9;
					}
				}
			}

			.main-head {
				background: #fff;

				.detail {
					display: flex;
					width: 100%;

					.detail-content {
						height: 100%;
						padding: 20px 20px 10px 0;
						flex: 1;

						.jieshao {
							margin-top: 10px;
							font-family: PingFang;
							font-weight: 400;
							color: #888888;
							line-height: 25px;

						}

						.company {
							margin-top: 5px;
							display: inline-block;
							padding: 0 10px;
							height: 29px;
							background: #E5EDFB;
							color: #0052D9;
							text-align: center;
							font-size: 14px;
							line-height: 29px;
						}

						.top {
							display: flex;
							justify-content: space-between;
							height: 40px;
							align-items: center;

							.username {
								font-size: 20px;
								font-weight: bold;
							}

							.letter {
								background: #FBF4E5;
								color: #D99D0E;
								transition: all .2s;
							}
							.letter:hover{
								background: #D99D0E;
								color: white;
							}
							.guanzhu {
								background: #E5EDFB;
								color: #0052D9;
								transition: all .2s;
							}
							.cancelGuanzhu{
								background: #fbb8bf;
								color: #fff;
								transition: all .2s;
							}
							.cancelGuanzhu:hover{
								background: #fb5363;
								color: #fff;
							}
							.guanzhu:hover{
								background: #0052D9;
								color: white;
							}
							.fans {
								cursor: pointer;
								line-height: 38px;
								text-align: center;
								margin-left: 25px;
								width: 108px;
								height: 38px;
								border-radius: 2px;

								i {
									font-size: 18px;
									line-height: 20px;
								}
							}
						}
					}

					.detail-pic {
						width: 150px;
						flex-wrap: wrap;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						padding-bottom: 10px;
						box-sizing: border-box;

						.image {
							width: 100px;
							height: 100px;
							overflow: hidden;
							border-radius: 50%;

							img {
								width: 100%;
								height: 100%;
							}
						}

						.renzheng {
							cursor: pointer;
							color: #222222;
							text-align: center;
							line-height: 33px;
							width: 83px;
							height: 33px;
							background: #EEEEEE;
						}
					}
				}

				display: flex;

				.level {
					width: 200px;
					height: 168px;
					background: #0052D9;
					padding: 20px;
					box-sizing: border-box;
					color: white;

					p {
						margin-bottom: 12px;
						font-size: 18px;
						font-family: PingFang;
						font-weight: bold;
					}
				}
			}

			width: 1120px;
		}

	}
</style>